// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"657bf61f","787":"689c405f"}[chunkId] + ".chunk.js";
};